import {ReactNode} from "react";

import Header from "./Header";
import Footer from "./Footer";
import Admin from "./Sidebar/Admin";

const Layout = ({ children }: { children: ReactNode }) => {

  return(
    <div id="page-top">
      <div id="wrapper">
        <Admin />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />

            <div className="container-fluid">
              {children}
            </div>
          </div>

          <Footer />
        </div>
      </div>

      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>

    </div>
  );
};

export default Layout;